import { render, staticRenderFns } from "./CKEditor.vue?vue&type=template&id=f921eeda"
import script from "./CKEditor.vue?vue&type=script&lang=ts"
export * from "./CKEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports